(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageGroupUsersController', manageGroupUsers);

    manageGroupUsers.$inject = [
        '$rootScope',
        '$uibModalInstance',
        'UsersApi',
        'GroupsApi',
        'group',
        'alerts',
    ];

    function manageGroupUsers(
        $rootScope,
        $uibModalInstance,
        UsersApi,
        GroupsApi,
        group,
        alerts,
    ) {
        var vm = this;

        vm.isLoading = false;

        vm.close = close;
        vm.getUsers = getUsers;
        vm.addUser = addUser;
        vm.removeUser = removeUser;
        vm.acceptRequest = acceptRequest;
        vm.declineRequest = declineRequest;
        vm.group = group;

        /**
         * Initiates this controller
         */
        function bootstrap() {
            getUsers();
        }

        /**
         * Close the modal window.
         *
         * @return {void}
         */
        function close() {
            $uibModalInstance.close();
        }

        /**
         * Updates user group variable.
         *
         * @return {boolean}
         */
        function updateInGroupStatus(value: boolean, user: any = null) {
            vm.users.data.forEach((u) => {
                if (user === null) {
                    u.groups.forEach((g) => {
                        if (g.id === group.id) {
                            // eslint-disable-next-line no-param-reassign
                            u.inGroup = value;
                        }
                    });
                } else if (u.id === user.id) {
                    // eslint-disable-next-line no-param-reassign
                    u.inGroup = value;
                }
            });
        }

        /**
         * Retrieves users from the API
         * @return {void}
         */
        function getUsers() {
            vm.isLoading = true;

            UsersApi.get(vm.filters, function handleUsersResponse(response) {
                vm.users = response;
                vm.pagination = response.meta.pagination;
                vm.isLoading = false;

                updateInGroupStatus(true);
            }, function handleUsersError() {
                vm.isLoading = false;
            });
        }

        /**
         * Adds a user to the group
         * @param  {object} user - API user object
         * @return {void}
         */
        function addUser(user) {
            GroupsApi.addUser(
                {
                    id: group.id,
                    user_id: user.id,
                },
                (response) => {

                    updateInGroupStatus(true, user);


                    alerts.emit({
                        theme: 'success',
                        title: 'User added to group',
                        messages: [],
                    });
                },
            );
        }

        /**
         * Removes a user from the group
         * @param  {object} user - API user object
         * @return {void}
         */
        function removeUser(user) {
            GroupsApi.removeUser(
                {
                    id: group.id,
                    user_id: user.id,
                },
                (response) => {

                    updateInGroupStatus(false, user);


                    alerts.emit({
                        theme: 'success',
                        title: 'User removed from group',
                        messages: [],
                    });
                },
            );
        }

        /**
         * Accepts a request and adds user to the group
         * @param  {object} request - API request object
         * @return {void}
         */
        function acceptRequest(request) {
            GroupsApi.acceptRequest(
                {
                    id: request.id,
                },
                (response) => {
                    vm.group.user_requests = vm.group.user_requests.filter((o) => o.id !== request.id);

                    alerts.emit({
                        theme: 'success',
                        title: 'User added to group',
                        messages: [],
                    });
                },
            );
        }
        /**
         * Declines a request
         * @param  {object} request - API request object
         * @return {void}
         */
        function declineRequest(request) {
            GroupsApi.declineRequest(
                {
                    id: request.id,
                },
                (response) => {
                    vm.group.user_requests = vm.group.user_requests.filter((o) => o.id !== request.id);

                    alerts.emit({
                        theme: 'success',
                        title: 'User request declined',
                        messages: [],
                    });
                },
            );
        }

        // init
        bootstrap();
    }
}(angular));
